var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listing-main"},[_c('div',{staticClass:"listing-main__inner"},[_c('ListingActionBar',_vm._b({},'ListingActionBar',Object.assign({}, _vm.actionBarProps),false)),_vm._v(" "),_c('div',{staticClass:"listing-data"},[_c('div',{staticClass:"listing-data__side"},[_vm._t("dataSide")],2),_vm._v(" "),_c('ListingDataMain',_vm._b({},'ListingDataMain',{
          iconDownloadUrl: _vm.iconDownloadUrl,
          iconExternalLinkUrl: _vm.iconExternalLinkUrl,
          sections: _vm.dataMainSections
        },false))],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }